import createVueComponent from '../createVueComponent';

const FolderOpen = createVueComponent('FolderOpenIcon', [
  [
    'path',
    {
      d:
        'M6 17l2-5h14l-3 8a2 2 0 01-2 1H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h7a2 2 0 012 2v4',
    },
  ],
]);

export default FolderOpen;
